import { AnsokanHomeComponent } from './ansokan-home/ansokan-home.component';
import { AnsokanComponent } from './ansokan/ansokan.component';
import { ANSOKAN_ROUTES } from './ansokan/constants/ansokan.routes';
import { APP_ROUTING_NAMES } from './app.routes.names';
import { LoginGuard } from './guard/login.guard';
import { ViewApplicationGuard } from './guard/view-application.guard';
import { LoggedInComponent } from './logged-in/logged-in.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SupplementComponent } from './supplement/supplement.component';
import { Routes } from "@angular/router";

export const APP_ROUTES: Routes = [
    { component: AnsokanHomeComponent, path: APP_ROUTING_NAMES.START },
    { path: '', pathMatch: 'full', redirectTo: APP_ROUTING_NAMES.START },
    {
        canActivate: [ViewApplicationGuard],
        children: ANSOKAN_ROUTES,
        component: AnsokanComponent,
        path: APP_ROUTING_NAMES.ANSOKAN_NO_LOGIN,
    },
    {
        component: SupplementComponent,
        path: APP_ROUTING_NAMES.SUPPLEMENT,
    },
    {
        component: LoggedInComponent,
        path: 'loggedin',
    },
    { component: NotFoundComponent, path: '**', pathMatch: 'full' },
];
